import React, { useEffect, useMemo } from "react";

import { BellNotificationsBlock } from "@remar/shared/dist/components/Notifications";
import { ButtonActionEnum, NotificationTypeId, NotificationsModel } from "@remar/shared/dist/models";

import { useAppDispatch, useAppSelector } from "store";
import { getFullState, getUserNotifications, markAsRead } from "store/features/notifications/notifications.slice";

const BellNotifications = () => {
	const dispatch = useAppDispatch();
	const { bellNotifications: bellNotificationsState } = useAppSelector(getFullState);

	useEffect(() => {
		// fetches filtered push notifications for bell/push notifications
		dispatch(
			getUserNotifications({
				filters: {
					"notification.notificationTypeId": [NotificationTypeId.AdminGeneratedPush]
				}
			})
		);
	}, [dispatch]);

	const bellNotifications = useMemo(() => {
		const userNotifications = bellNotificationsState?.items || [];
		return userNotifications.map(un => {
			const { action: buttonAction, url } = (un.notification as NotificationsModel).data!.primaryButton!;
			const _action = () => {
				switch (buttonAction) {
					case ButtonActionEnum.OpenLink: {
						window.open(url, "_blank");
						break;
					}
				}
			};
			return { ...un, action: _action };
		});
	}, [bellNotificationsState]);

	return (
		<BellNotificationsBlock
			markAsRead={(notificationId?: number) => {
				dispatch(
					markAsRead({
						id: notificationId,
						callbackfn() {
							dispatch(
								getUserNotifications({
									filters: {
										"notification.notificationTypeId": [NotificationTypeId.AdminGeneratedPush]
									}
								})
							);
						}
					})
				);
			}}
			bellNotifications={bellNotifications}
			unreadCount={bellNotificationsState.totalUnread}
		/>
	);
};

export default BellNotifications;
